// Types
import { GetAllHomePageData_featuredPpvEvents } from 'api/homePage/types/GetAllHomePageData';
import { GetFeaturedStreams } from 'api/homePage/types/GetFeaturedStreams';
import { StreamType } from 'api/graphql-global-types';
// Helpers
import { formatPriceToUSD, getStreamButtonText } from 'helpers/priceText';

export type FeaturedStreamsType =
  | GetAllHomePageData_featuredPpvEvents
  | GetFeaturedStreams['featuredPpvEvents'][number];

type FeaturedStream = FeaturedStreamsType['stream'];

export const getFeaturedStreamActionState = (
  stream: FeaturedStream,
  userId?: string | null,
  showOfficialPpvTag = true
) => {
  const isInterview = stream.type === StreamType.Interview;
  // Auto-freed PPV keeps its original price, so `isFree` — not a zero price —
  // is what decides whether the slide is free to watch.
  const isFree =
    stream.isFree === true ||
    (stream.price != null && Number(stream.price) === 0);
  const isUserStreamCreator = userId === stream.store?.id;
  const hasAccessToWatch =
    isFree ||
    ('isPurchased' in stream && stream.isPurchased) ||
    isUserStreamCreator;

  return {
    hasAccessToWatch,
    isUserStreamCreator,
    showOfficialPpvTagForSlide: showOfficialPpvTag && !isInterview && !isFree,
    buttonText: getStreamButtonText(
      stream.price,
      formatPriceToUSD,
      isInterview,
      hasAccessToWatch
    ),
  };
};
